import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import { concat } from 'rxjs/observable/concat';
import { type ActionsObservable } from 'redux-observable';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { updateOnDemandActivationModalState } from '../ui/ondemand-activation/actions';
import { getActivationStatus } from '../activation/selectors';
import { initializeView } from '../actions/initialize-view';
import { updateConfluenceState } from '../actions';
import {
	MARK_ACTIVATION_COMPLETED,
	type markActivationCompleted,
	updateConfluenceActivationStatus,
} from '../actions/activate-confluence';
import { type Store } from 'redux';
import { type State } from '../types';

type Action =
	| ReturnType<typeof markActivationCompleted>
	| ReturnType<typeof updateOnDemandActivationModalState>;

function getObservables(action$: ActionsObservable<Action>) {
	return combineLatest(action$.ofType(MARK_ACTIVATION_COMPLETED));
}

export default (action$: ActionsObservable<Action>, store: Store<State>) => {
	return getObservables(action$)
		.filter(() => {
			return getActivationStatus(store.getState()) === 'activating';
		})
		.switchMap(() => {
			return concat([
				updateOnDemandActivationModalState({
					modalState: 'closed',
				}),
				updateConfluenceState('CONFLUENCE_LOADING'),
				updateConfluenceActivationStatus({
					status: 'completed',
				}),
				initializeView(),
			]);
		});
};
